import * as echarts from "echarts";

const DEFAULT_TOOLTIP_INTERVAL = 3000;

export function createTooltipAutoPlay(
  chart,
  { interval = DEFAULT_TOOLTIP_INTERVAL, autoStart = true } = {}
) {
  if (!chart || typeof chart.dispatchAction !== "function") {
    return {
      pause() {},
      resume() {},
      stop() {}
    };
  }

  let dataIndex = 0;
  let timer = null;
  const safeInterval = Math.max(Number(interval) || DEFAULT_TOOLTIP_INTERVAL, 1);

  const showNextTooltip = () => {
    const option = typeof chart.getOption === "function" ? chart.getOption() : {};
    const series = Array.isArray(option.series) ? option.series : [];
    const dataLength = series.reduce((maxLength, item) => {
      const data = item && Array.isArray(item.data) ? item.data : [];
      return Math.max(maxLength, data.length);
    }, 0);

    if (!dataLength) {
      return;
    }

    dataIndex %= dataLength;
    chart.dispatchAction({
      type: "showTip",
      seriesIndex: 0,
      dataIndex
    });
    dataIndex = (dataIndex + 1) % dataLength;
  };

  const pause = () => {
    if (!timer) {
      return;
    }

    window.clearInterval(timer);
    timer = null;
  };

  const resume = () => {
    if (timer) {
      return;
    }

    timer = window.setInterval(showNextTooltip, safeInterval);
  };

  const start = () => {
    showNextTooltip();
    resume();
  };

  const stop = () => {
    pause();
    chart.dispatchAction({ type: "hideTip" });
  };

  if (autoStart) {
    start();
  }

  return { pause, resume, stop };
}

export function createGradientLineSeries({
  name,
  data,
  color,
  areaStartColor
}) {
  return {
    name,
    type: "line",
    smooth: true,
    lineStyle: { color, width: 2 },
    symbol: "circle",
    symbolSize: 6,
    itemStyle: { color, borderColor: "#fff", borderWidth: 1 },
    areaStyle: {
      opacity: 0.8,
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: areaStartColor },
        { offset: 1, color: areaStartColor.replace(/,[^,]+\)$/, ", 0)") }
      ])
    },
    emphasis: { focus: "series" },
    data: data || []
  };
}

export function createDarkLineOption({ title = "", labels = [], series = [] }) {
  return {
    title: title
      ? {
          text: title,
          textStyle: { color: "#fff", fontWeight: "500", fontSize: 18 }
        }
      : {},
    tooltip: { trigger: "axis" },
    legend: {
      data: series.map(item => item.name),
      right: 0,
      textStyle: {
        color: "rgba(255,255,255,0.8)",
        fontWeight: "400",
        fontSize: 12
      }
    },
    grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
    xAxis: {
      type: "category",
      boundaryGap: false,
      axisLabel: { color: "#ffffff", fontSize: 12, fontWeight: "normal" },
      data: labels
    },
    yAxis: {
      type: "value",
      axisLabel: { color: "#ffffff", fontSize: 12, fontWeight: "normal" }
    },
    series
  };
}
